import { Dispatch, SetStateAction } from 'react'
import { TokenTransfer, Transaction } from '../../app/models/generated'
import { NavigateFunction } from 'react-router-dom'
import { baseUrl } from '../../constants/api.const'

export async function getTransaction(
    setTransaction: Dispatch<SetStateAction<Transaction>>,
    address: string | undefined,
    navigate: NavigateFunction
) {
    const url = `${baseUrl}/transactions/${address}`
    const fetchResult: Response = await fetch(url)
    if (fetchResult.status != 200) {
        navigate('/error')
    } else {
        const result: Transaction = await fetchResult.json()
        setTransaction(result)
    }
}

export interface TokenTransferList {
    items: Array<TokenTransfer>
    next_page_params: Record<string, string> | null
}

export async function getTokenTransfers(
    setTokenTransfers: Dispatch<SetStateAction<TokenTransferList>>,
    address: string | undefined,
    params: Record<string, string>
) {
    const url = baseUrl + '/transactions/' + address + '/token-transfers?'
    const searchParams = new URLSearchParams(params)

    const result: TokenTransferList = await (
        await fetch(url + searchParams.toString())
    ).json()
    setTokenTransfers(result)
}